import { LOCALE_ID, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { VerifyCodeComponent } from './pages/verify-code/verify-code.component';
import { privateAuth } from './services/guards/auth.guard';
import { TemplateFormComponent } from './pages/template-form/template-form.component';
import { AnamneseAnswersComponent } from './pages/anamnese-answers/anamnese-answers.component';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { UploadPhotosComponent } from './pages/treatment-plan/upload-product-photos/upload-photos.component';
import { UploadTreatmentPhotosComponent } from './pages/treatment-plan/upload-treatment-photos/upload-treatment-photos.component';
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';
import { AnamneseInvalidComponent } from './pages/anamnese-invalid/anamnese-invalid.component';
import { AnamneseSuccessComponent } from './pages/anamnese-success/anamnese-success.component';
import { LinkInvalidComponent } from './pages/link-invalid/link-invalid.component';
import { ApiDocsComponent } from './pages/api-docs/api-docs.component';

import { MainV2Component } from './layouts/main-v2/main-v2.component';
import { CompanyComponent } from './layouts/main-v2/pages/company/company.component';
import { CompanyFormComponentV2 } from './layouts/main-v2/pages/company-form/company-form.component';
import { InfoComponent } from './layouts/main-v2/pages/company-form/steps/info/info.component';
import { ContactComponent } from './layouts/main-v2/pages/company-form/steps/contact/contact.component';
import { SettingsComponent } from './layouts/main-v2/pages/company-form/steps/settings/settings.component';
import { ProvidersComponent } from './layouts/main-v2/pages/providers/providers.component';
import { ProviderFormComponent as ProviderFormComponentV2 } from './layouts/main-v2/pages/providers-form/provider-form.component';
import { ProviderEditComponent } from './layouts/main-v2/pages/providers-edit/provider-edit.component';
import { UsersV2Component } from './layouts/main-v2/pages/users/users.component';
import { UserFormV2Component } from './layouts/main-v2/pages/user-form/user-form.component';
import { UserEditV2Component } from './layouts/main-v2/pages/user-edit/user-edit.component';
import { ProceduresV2Component } from './layouts/main-v2/pages/procedures/procedures.component';
import { ProcedureFormV2Component } from './layouts/main-v2/pages/procedure-form/procedure-form.component';
import { ProcedureEditV2Component } from './layouts/main-v2/pages/procedure-edit/procedure-edit.component';
import { PatientsV2Component } from './layouts/main-v2/pages/patients/patients.component';
import { PatientFormV2Component } from './layouts/main-v2/pages/patient-form/patient-form.component';
import { PatientEditV2Component } from './layouts/main-v2/pages/patient-edit/patient-edit.component';
import { AnamneseViewV2Component } from './layouts/main-v2/pages/anamnese-view/anamnese-view.component';
import { AnamneseCreateV2Component } from './layouts/main-v2/pages/anamnese-create/anamnese-create.component';
import { GenerateDocsV2Component } from './layouts/main-v2/pages/generate-docs/generate-docs.component';
import { DocumentFormV2Component } from './layouts/main-v2/pages/document-form/document-form.component';
import { DocumentSuccessV2Component } from './layouts/main-v2/pages/document-success/document-success.component';
import { PendingAnamnesesV2Component } from './layouts/main-v2/pages/pending-anamneses/pending-anamneses.component';
import { PendingSignaturesV2Component } from './layouts/main-v2/pages/pending-signatures/pending-signatures.component';
import { TreatmentPlansV2Component } from './layouts/main-v2/pages/treatment-plans/treatment-plans.component';
import { TreatmentPlanDetailV2Component } from './layouts/main-v2/pages/treatment-plan-detail/treatment-plan-detail.component';
import { IncidentDetailV2Component } from './layouts/main-v2/pages/incident-detail/incident-detail.component';
import { DashboardV2Component } from './layouts/main-v2/pages/dashboard/dashboard.component';
import { AlunosV2Component } from './layouts/main-v2/pages/alunos/alunos.component';
import { AlunosFormsV2Component } from './layouts/main-v2/pages/alunos/forms.component';
import { TerceirosV2Component } from './layouts/main-v2/pages/terceiros/terceiros.component';
import { TemplatesV2Component } from './layouts/main-v2/pages/templates/templates.component';
import { StandaloneDocsV2Component } from './layouts/main-v2/pages/standalone-docs/standalone-docs.component';
import { RootOnlyGuard } from './guards/root-only.guard';
import { ClinicGroupsV2Component } from './layouts/main-v2/pages/clinic-groups/clinic-groups.component';
import { ClinicGroupDetailComponent } from './layouts/main-v2/pages/clinic-group-detail/clinic-group-detail.component';
import { ClinicGroupFormV2Component } from './layouts/main-v2/pages/clinic-group-form/clinic-group-form.component';
import { IncidentQuestionsComponent } from './layouts/main-v2/pages/incident-questions/incident-questions.component';
// Using shared PendingSignaturesV2Component for signatures pages across modules

registerLocaleData(localePt);

const routes: Routes = [
      {
        path: 'terceiros/create',
        component: PatientFormV2Component,
      },
      {
        path: 'terceiros/:patientId/edit',
        component: PatientEditV2Component,
      },
      {
        path: 'terceiros',
        component: PatientsV2Component,
      },
  {
    path: '',
    component: LandingPageComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'verify-code',
    component: VerifyCodeComponent
  },
  {
    path: 'anamneses/:anamneseId/form',
    component: AnamneseAnswersComponent,
  },
  {
    path: 'formularios/:anamneseId/form',
    component: AnamneseAnswersComponent,
  },
  {
    path: 'anamnese-invalid',
    component: AnamneseInvalidComponent
  },
  {
    path: 'anamnese-success',
    component: AnamneseSuccessComponent
  },
  {
    path: 'link-invalid',
    component: LinkInvalidComponent
  },
  // Rotas wildcard para capturar URLs inválidas de anamneses/formulários (link com texto extra)
  {
    path: 'anamneses/**',
    component: LinkInvalidComponent
  },
  {
    path: 'formularios/**',
    component: LinkInvalidComponent
  },
  {
    path: 'upload-photos',
    component: UploadPhotosComponent
  },
  {
    path: 'upload-treatment-photos',
    component: UploadTreatmentPhotosComponent
  },
  // Redirect legacy V1 routes to V2
  {
    path: 'main',
    pathMatch: 'full',
    redirectTo: 'main/v2'
  },
  {
    path: 'main/home',
    redirectTo: 'main/v2'
  },
  {
    path: 'main/dashboard',
    redirectTo: 'main/v2/dashboard'
  },
  // LAYOUT V2
  {
    path: 'main/v2',
    component: MainV2Component,
    canActivate: [privateAuth],
    children: [
       {
        path: 'company',
        data: {
          breadcrumb: 'Empresas',
          button: {
            label: 'Criar empresa',
            action: 'create'
          },
        },
        children: [
          {
            path: '',
            component: CompanyComponent
          },
          {
            path: 'create',
            component: CompanyFormComponentV2,
            children: [
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'info'
              },
              {
                path: 'info',
                component: InfoComponent,
                data: { breadcrumb: 'Criar Empresa', stepIndex: 0 }
              },
              {
                path: 'contact',
                component: ContactComponent,
                data: { breadcrumb: 'Criar Empresa', stepIndex: 1 }
              },
              {
                path: 'settings',
                component: SettingsComponent,
                data: { breadcrumb: 'Criar Empresa', stepIndex: 2 }
              }
            ]
          },
          {
            path: ':id/edit',
            component: CompanyFormComponentV2,
            data: {
              breadcrumb: 'Editar',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            },
            children: [
              {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full'
              },
              {
                path: 'info',
                component: InfoComponent,
                data: { breadcrumb: 'Editar Empresa', stepIndex: 0 }
              },
              {
                path: 'contact',
                component: ContactComponent,
                data: { breadcrumb: 'Editar Empresa', stepIndex: 1 }
              },
              {
                path: 'settings',
                component: SettingsComponent,
                data: { breadcrumb: 'Editar Empresa', stepIndex: 2 }
              }
            ]
          }
        ]
      },
      {
        path: 'providers',
        data: {
          breadcrumb: 'Prestadores',
          button: {
            label: 'Criar prestador',
            action: 'create'
          },
        },
        children: [
          {
            path: '',
            component: ProvidersComponent
          },
          {
            path: 'create',
            component: ProviderFormComponentV2,
            canActivate: [RootOnlyGuard],
            data: {
              breadcrumb: 'Criar Prestador',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: ':providerId/edit',
            component: ProviderEditComponent,
            data: {
              breadcrumb: 'Editar Prestador',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          }
        ]
      },
      {
        path: 'users',
        data: {
          breadcrumb: 'Usuários',
          button: {
            label: 'Criar usuário',
            action: 'create'
          },
        },
        children: [
          {
            path: '',
            component: UsersV2Component
          },
          {
            path: 'create',
            component: UserFormV2Component,
            data: {
              breadcrumb: 'Criar Usuário',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: ':userId/edit',
            component: UserEditV2Component,
            data: {
              breadcrumb: 'Editar Usuário',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          }
        ]
      },
      {
        path: 'procedures',
        data: {
          breadcrumb: 'Procedimentos',
          button: {
            label: 'Criar procedimento',
            action: 'create'
          },
        },
        children: [
          {
            path: '',
            component: ProceduresV2Component
          },
          {
            path: 'create',
            component: ProcedureFormV2Component,
            data: {
              breadcrumb: 'Criar Procedimento',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: ':procedureId/edit',
            component: ProcedureEditV2Component,
            data: {
              breadcrumb: 'Editar Procedimento',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          }
        ]
      },
      {
        path: 'patients',
        data: {
          breadcrumb: 'Pacientes',
          button: {
            label: 'Criar paciente',
            action: 'create'
          },
        },
        children: [
          {
            path: '',
            component: PatientsV2Component
          },
          {
            path: 'create',
            component: PatientFormV2Component,
            data: {
              breadcrumb: 'Criar Paciente',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: ':patientId/edit',
            component: PatientEditV2Component,
            data: {
              breadcrumb: 'Ficha do Paciente',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: 'anamnese/create',
            component: AnamneseCreateV2Component,
            data: {
              breadcrumb: 'Nova Anamnese',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: 'anamnese/:anamneseId',
            component: AnamneseViewV2Component,
            data: {
              breadcrumb: 'Ficha de Anamnese',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: 'anamnese/:anamneseId/view',
            component: AnamneseCreateV2Component,
            data: {
              breadcrumb: 'Anamnese Enviada',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: 'anamnese/:anamneseId/answers',
            component: AnamneseViewV2Component,
            data: {
              breadcrumb: 'Respostas da Anamnese',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: 'generate-docs/:anamneseId',
            component: GenerateDocsV2Component,
            data: {
              breadcrumb: 'Gerar Documentos',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: 'document-form',
            component: DocumentFormV2Component,
            data: {
              breadcrumb: 'Preencher Documentos',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: 'document-form/success',
            component: DocumentSuccessV2Component,
            data: {
              breadcrumb: 'Documentos Gerados',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: 'standalone-docs',
            component: StandaloneDocsV2Component,
            data: {
              breadcrumb: 'Documentos Avulsos',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          }
        ]
      },
      {
        path: 'anamneses',
        component: PendingAnamnesesV2Component,
        data: {
          breadcrumb: 'Anamneses'
        }
      },
      {
        path: 'signatures',
        component: PendingSignaturesV2Component,
        data: {
          breadcrumb: 'Assinaturas'
        }
      },
      {
        path: 'treatment-plans',
        component: TreatmentPlansV2Component,
        data: {
          breadcrumb: 'Planos de Tratamento'
        }
      },
      {
        path: 'treatment-plan/:id',
        component: TreatmentPlanDetailV2Component,
        canDeactivate: [UnsavedChangesGuard],
        data: {
          breadcrumb: 'Detalhes do Plano',
          button: {
            label: 'Voltar',
            action: 'back'
          }
        }
      },
      {
        path: 'treatment-plan/:id/incident',
        component: IncidentDetailV2Component,
        data: {
          breadcrumb: 'Intercorrência',
          button: {
            label: 'Voltar',
            action: 'back'
          }
        }
      },
      // Rota dinâmica para qualquer módulo (exceto PACIENTES que tem rotas específicas)
      {
        path: 'modules/:moduleName',
        data: {
          breadcrumb: 'Módulo',
          button: {
            label: 'Criar registro',
            action: 'create'
          }
        },
        children: [
          { path: '', component: PatientsV2Component },
          { path: 'create', component: PatientFormV2Component, data: { breadcrumb: 'Criar Registro' } },
          { path: ':patientId/edit', component: PatientEditV2Component, data: { breadcrumb: 'Editar Registro' } },
          { path: 'anamnese/create', component: AnamneseCreateV2Component, data: { breadcrumb: 'Novo Formulário' } },
          { path: 'anamnese/:anamneseId', component: AnamneseViewV2Component, data: { breadcrumb: 'Ficha de Formulário' } },
          { path: 'anamnese/:anamneseId/view', component: AnamneseCreateV2Component, data: { breadcrumb: 'Formulário Enviado' } },
          { path: 'anamnese/:anamneseId/answers', component: AnamneseViewV2Component, data: { breadcrumb: 'Respostas do Formulário' } },
          { path: 'generate-docs/:anamneseId', component: GenerateDocsV2Component, data: { breadcrumb: 'Gerar Documentos' } },
          { path: 'document-form', component: DocumentFormV2Component, data: { breadcrumb: 'Preencher Documentos' } },
          { path: 'document-form/success', component: DocumentSuccessV2Component, data: { breadcrumb: 'Documentos Gerados' } },
          { 
            path: 'forms', 
            component: PendingAnamnesesV2Component, 
            data: { 
              breadcrumb: 'Formulários',
              button: null
            } 
          },
          { path: 'signatures', component: PendingSignaturesV2Component, data: { breadcrumb: 'Assinaturas' } }
        ]
      },
      // Rotas específicas mantidas para compatibilidade (redirecionam internamente)
      {
        path: 'alunos',
        data: {
          breadcrumb: 'Alunos',
          button: {
            label: 'Criar aluno',
            action: 'create'
          }
        },
        children: [
          { path: '', component: PatientsV2Component },
          { path: 'create', component: PatientFormV2Component, data: { breadcrumb: 'Criar Aluno' } },
          { path: ':patientId/edit', component: PatientEditV2Component, data: { breadcrumb: 'Editar Aluno' } },
          { path: 'anamnese/create', component: AnamneseCreateV2Component, data: { breadcrumb: 'Nova Anamnese' } },
          { path: 'anamnese/:anamneseId', component: AnamneseViewV2Component, data: { breadcrumb: 'Ficha de Anamnese' } },
          { path: 'anamnese/:anamneseId/view', component: AnamneseCreateV2Component, data: { breadcrumb: 'Anamnese Enviada' } },
          { path: 'anamnese/:anamneseId/answers', component: AnamneseViewV2Component, data: { breadcrumb: 'Respostas da Anamnese' } },
          { path: 'generate-docs/:anamneseId', component: GenerateDocsV2Component, data: { breadcrumb: 'Gerar Documentos' } },
          { path: 'document-form', component: DocumentFormV2Component, data: { breadcrumb: 'Preencher Documentos' } },
          { path: 'document-form/success', component: DocumentSuccessV2Component, data: { breadcrumb: 'Documentos Gerados' } },
          { 
            path: 'forms', 
            component: PendingAnamnesesV2Component, 
            data: { 
              breadcrumb: 'Formulários de Alunos',
              button: null
            } 
          },
          { path: 'signatures', component: PendingSignaturesV2Component, data: { breadcrumb: 'Assinaturas de Alunos' } }
        ]
      },
      {
        path: 'terceiros',
        data: {
          breadcrumb: 'Terceiros',
          button: {
            label: 'Criar terceiro',
            action: 'create'
          }
        },
        children: [
          { path: '', component: PatientsV2Component },
          { path: 'create', component: PatientFormV2Component, data: { breadcrumb: 'Criar Terceiro' } },
          { path: ':patientId/edit', component: PatientEditV2Component, data: { breadcrumb: 'Editar Terceiro' } },
          { path: 'anamnese/create', component: AnamneseCreateV2Component, data: { breadcrumb: 'Nova Anamnese' } },
          { path: 'anamnese/:anamneseId', component: AnamneseViewV2Component, data: { breadcrumb: 'Ficha de Anamnese' } },
          { path: 'anamnese/:anamneseId/view', component: AnamneseCreateV2Component, data: { breadcrumb: 'Anamnese Enviada' } },
          { path: 'anamnese/:anamneseId/answers', component: AnamneseViewV2Component, data: { breadcrumb: 'Respostas da Anamnese' } },
          { path: 'generate-docs/:anamneseId', component: GenerateDocsV2Component, data: { breadcrumb: 'Gerar Documentos' } },
          { path: 'document-form', component: DocumentFormV2Component, data: { breadcrumb: 'Preencher Documentos' } },
          { path: 'document-form/success', component: DocumentSuccessV2Component, data: { breadcrumb: 'Documentos Gerados' } },
          { 
            path: 'forms', 
            component: PendingAnamnesesV2Component, 
            data: { 
              breadcrumb: 'Formulários de Terceiros',
              button: null
            } 
          },
          { path: 'signatures', component: PendingSignaturesV2Component, data: { breadcrumb: 'Assinaturas de Terceiros' } }
        ]
      },
      {
        path: 'clinic-groups',
        canActivate: [RootOnlyGuard],
        data: {
          breadcrumb: 'Grupos de Clínicas',
          button: {
            label: 'Novo Grupo',
            action: 'create'
          }
        },
        children: [
          {
            path: '',
            component: ClinicGroupsV2Component
          },
          {
            path: 'create',
            component: ClinicGroupFormV2Component,
            data: {
              breadcrumb: 'Criar Grupo',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: ':id/edit',
            component: ClinicGroupDetailComponent,
            data: {
              breadcrumb: 'Editar Grupo',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          }
        ]
      },
      {
        path: 'incident-questions',
        component: IncidentQuestionsComponent,
        canActivate: [RootOnlyGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: { breadcrumb: 'Perguntas de Intercorrência' }
      },
      {
        path: 'dashboard',
        component: DashboardV2Component,
        data: { breadcrumb: 'Dashboard' }
      },
      {
        path: 'templates',
        data: {
          breadcrumb: 'Templates',
          button: {
            label: 'Criar template',
            action: 'create'
          }
        },
        children: [
          {
            path: '',
            component: TemplatesV2Component
          },
          {
            path: 'create',
            component: TemplateFormComponent,
            data: {
              breadcrumb: 'Criar Template',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          },
          {
            path: ':templateId/edit',
            component: TemplateFormComponent,
            data: {
              breadcrumb: 'Editar Template',
              button: {
                label: 'Voltar',
                action: 'back'
              }
            }
          }
        ]
      },
    ]
  },
  // Documentação da API para parceiros (rota pública)
  {
    path: 'developer/api-docs',
    component: ApiDocsComponent
  },
  // Rota wildcard global - redireciona URLs não encontradas para página de link inválido
  {
    path: '**',
    component: LinkInvalidComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
})
export class AppRoutingModule { }
